import { createLazyComponent } from '@muse-web/router'

import type { TAudioLicenseSectionProps } from './AudioLicense.types'
import { AudioLicenseFallback } from './AudioLicenseFallback'

const loadAudioLicenseSection = () =>
    import(/* webpackChunkName: 'audio-license' */ './AudioLicenseSection')

export const AsyncAudioLicense = createLazyComponent<
    TAudioLicenseSectionProps,
    'AudioLicenseSection'
>(loadAudioLicenseSection, 'AudioLicenseSection', {
    keepServerMarkup: true,
    fallback: AudioLicenseFallback,
})
